import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async getMe ({ commit, dispatch }) {
    try {
      const { data } = await directus.getMe()
      commit('setAttr', {
        name: 'userId',
        value: data.id
      })

      return true
    } catch (err) {
      errorDirectus(err, dispatch)
      return false
    }
  }
}
